import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api/admin";

const adminHeaders = () => ({
  "X-Admin-Password": sessionStorage.getItem("nt_admin_token") || "",
});

export const adminLogin = (password) =>
  axios.post(`${BASE}/login`, { password });

export const adminGetStats = () =>
  axios.get(`${BASE}/stats`, { headers: adminHeaders() });

export const adminListCourses = () =>
  axios.get(`${BASE}/courses`, { headers: adminHeaders() });

export const adminCreateCourse = (data) =>
  axios.post(`${BASE}/courses`, data, { headers: adminHeaders() });

export const adminUpdateCourse = (identifier, data) =>
  axios.put(`${BASE}/courses/${encodeURIComponent(identifier)}`, data, {
    headers: adminHeaders(),
  });

export const adminDeleteCourse = (identifier) =>
  axios.delete(`${BASE}/courses/${encodeURIComponent(identifier)}`, {
    headers: adminHeaders(),
  });

export const adminAddLesson = (identifier, data) =>
  axios.post(`${BASE}/courses/${encodeURIComponent(identifier)}/lessons`, data, {
    headers: adminHeaders(),
  });

export const adminUpdateLesson = (identifier, lessonId, data) =>
  axios.put(
    `${BASE}/courses/${encodeURIComponent(identifier)}/lessons/${lessonId}`,
    data,
    { headers: adminHeaders() }
  );

export const adminDeleteLesson = (identifier, lessonId) =>
  axios.delete(
    `${BASE}/courses/${encodeURIComponent(identifier)}/lessons/${lessonId}`,
    { headers: adminHeaders() }
  );

export const adminUpdateExam = (identifier, data) =>
  axios.put(`${BASE}/courses/${encodeURIComponent(identifier)}/exam`, data, {
    headers: adminHeaders(),
  });

export const adminUploadImage = (file, folder = "uploads") => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${BASE}/upload?folder=${folder}`, formData, {
    headers: {
      ...adminHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
};
